<template>
  <div class="row-box">
    <WrapperField
      v-for="(value, key) in data"
      :key="value + key"
      :data="
        createDataField({
          fieldName: key,
          fieldValue: value,
          fieldGroup: FieldGroup.ACCEPTANCE_DEPOSIT_DETAILS,
        })
      "
    />

    <template v-if="data.obligationDocument">
      <TitleField
        :fieldName="FieldName.obligationDocument.IS_OBLIGATION_DOCUMENT"
        :fieldGroup="FieldGroup.OBLIGATION_DOCUMENT"
      />
      <WrapperField
        v-for="(value, key) in data.obligationDocument"
        :key="value + key"
        :data="
          createDataField({
            fieldName: key,
            fieldValue: value,
            fieldGroup: FieldGroup.OBLIGATION_DOCUMENT,
          })
        "
      />
    </template>
  </div>
</template>

<script>
import { createDataField, FieldGroup } from '@/utils/fullStatementView';
import WrapperField from '@/components/elements/statement/FullStatementView/base/WrapperField';
import TitleField from '@/components/elements/statement/FullStatementView/base/TitleField';
import { FieldName } from '@/constants';

export default {
  name: 'Step3',
  props: ['data'],
  components: {
    WrapperField,
    TitleField,
  },
  data: () => ({
    FieldGroup,
    FieldName,
    createDataField,
  }),
};
</script>

<style scoped></style>
